import { useState } from 'react'

import GlobalSearchService from '@space-shell/common/services/globalSearch/service'
import type { GetGlobalFindParams } from '@space-shell/common/services/globalSearch/types'
import { useInfiniteQuery } from '@tanstack/react-query'

import { MAX_RESULTS_PER_PAGE } from '../constants'
import type { UseSearchResultsProps } from '../types'

const useSearchResults = ({ term, enableSearch, membership }: UseSearchResultsProps) => {
  const [countShowMore, setCountShowMore] = useState(0)

  const fetchData = async ({ pageParam }: { pageParam?: GetGlobalFindParams }) => {
    const data = await GlobalSearchService.getGlobalFind({
      membershipSlug: membership,
      term: pageParam?.term || term,
      searchAfter: pageParam?.searchAfter
    })

    setCountShowMore((prev) => prev + 1)

    return data
  }

  return useInfiniteQuery(['getTermsGlobalSearch', term], fetchData, {
    enabled: enableSearch,
    retry: 1,
    getNextPageParam: (lastPage) => {
      const hasValidResults = Boolean(
        Array.isArray(lastPage.results) &&
          lastPage.results.length > MAX_RESULTS_PER_PAGE &&
          lastPage.paging.size < lastPage.paging.total &&
          countShowMore < lastPage.paging.total / lastPage.paging.size
      )

      return hasValidResults
    }
  })
}

export default useSearchResults
